'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _FormGroup = require('../FormInputs/FormGroup');

var _FormGroup2 = _interopRequireDefault(_FormGroup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // NPM


var CopiableText = function (_PureComponent) {
  _inherits(CopiableText, _PureComponent);

  function CopiableText(props) {
    _classCallCheck(this, CopiableText);

    var _this = _possibleConstructorReturn(this, (CopiableText.__proto__ || Object.getPrototypeOf(CopiableText)).call(this, props));

    _this.copyText = function () {
      _this.textInput.select();
      document.execCommand('copy');
      _this.setState({ copied: true });
    };

    _this.state = {
      copied: false
    };
    return _this;
  }

  _createClass(CopiableText, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          labelText = _props.labelText,
          textToCopy = _props.textToCopy;

      return _react2.default.createElement(
        _FormGroup2.default,
        { className: 'CopiableText', text: labelText },
        _react2.default.createElement('input', {
          className: 'CopiableText-input',
          ref: function ref(textInput) {
            return _this2.textInput = textInput;
          },
          type: 'text',
          readOnly: true,
          value: textToCopy
        }),
        _react2.default.createElement(
          'button',
          { className: 'CopiableText-btn', onClick: this.copyText },
          this.state.copied ? 'Copied!' : 'Copy Link'
        )
      );
    }
  }]);

  return CopiableText;
}(_react.PureComponent);

CopiableText.propTypes = {
  textToCopy: _propTypes2.default.string.isRequired,
  labelText: _propTypes2.default.string.isRequired
};

exports.default = CopiableText;


//////////////////
// WEBPACK FOOTER
// ../frontend-component-library/build/Components/Utility/CopiableText.js
// module id = 609
// module chunks = 0